/**
 * DTO para upload de arquivos
 * Centraliza a definição de tipos para evitar duplicação
 */
export interface FileUploadDto {
  files: File[];
  fileName: string;
  fileSize: number;
  status: 'idle' | 'uploading' | 'success' | 'error';
  progress: number;
  error?: string;
}

/**
 * Factory para criar instâncias de FileUploadDto
 */
export function createFileUploadDto(): FileUploadDto {
  return {
    files: [],
    fileName: '',
    fileSize: 0,
    status: 'idle',
    progress: 0
  };
}

/**
 * DTO para criação de curso
 */
export interface ICourseCreateDto {
  title: string;
  description: string;
  teacherId: string;
  price: number;
  isPublic: boolean;
}

/**
 * Validações para formulário de curso
 */
export const COURSE_FORM_VALIDATORS = {
  title: {
    required: 'Título é obrigatório',
    minlength: 'Título deve ter pelo menos 3 caracteres',
    maxlength: 'Título deve ter no máximo 200 caracteres'
  },
  description: {
    required: 'Descrição é obrigatória',
    minlength: 'Descrição deve ter pelo menos 6 caracteres',
    maxlength: 'Descrição deve ter no máximo 2000 caracteres'
  },
  teacherId: {
    required: 'Selecione um professor'
  },
  price: {
    required: 'Preço é obrigatório',
    min: 'Preço não pode ser negativo'
  }
};

/**
 * Validações para formulário de professor
 */
export const TEACHER_FORM_VALIDATORS = {
  name: {
    required: 'Nome é obrigatório',
    minlength: 'Nome deve ter pelo menos 3 caracteres',
    maxlength: 'Nome deve ter no máximo 100 caracteres'
  },
  email: {
    required: 'Email é obrigatório',
    pattern: 'Email inválido'
  },
  bio: {
    maxlength: 'Bio deve ter no máximo 500 caracteres'
  }
};
